import type { DataTableColumn } from '@/components/custom/erp';
import type { MauSoHoaDon, NhomLoaiHD } from '@/types/schemas';
import { Checkbox } from '@/components/ui/checkbox';

export const getDataTableColumns = (): DataTableColumn<MauSoHoaDon>[] => [
  {
    field: 'ma_mau_so',
    headerName: 'Mã mẫu hóa đơn',
    width: 150
  },
  {
    field: 'ten_mau_so',
    headerName: 'Tên mẫu hóa đơn',
    width: 250
  },
  {
    field: 'nhom_loai_hd_data',
    headerName: 'Nhóm loại hóa đơn',
    width: 180,
    renderCell: params => params?.row?.nhom_loai_hd_data?.ten_nhom || null
  },
  {
    field: 'hddt_yn',
    headerName: 'Mẫu HĐĐT',
    width: 150,
    renderCell: params => (
      <div className='flex h-full w-full items-center justify-center'>
        <Checkbox checked={params.value === true || params.value === 1} disabled />
      </div>
    )
  }
];

interface InvoiceAccountLookupRow {
  code: string;
  name: string;
  parent_account_code?: string | null;
  parent_account_code_data?: {
    code?: string;
  } | null;
  status?: string;
}

export const accountColumns: DataTableColumn<InvoiceAccountLookupRow>[] = [
  {
    field: 'code',
    headerName: 'Mã tài khoản',
    width: 150
  },
  {
    field: 'name',
    headerName: 'Tên tài khoản',
    width: 250
  },
  {
    field: 'parent_account_code',
    headerName: 'Tài khoản mẹ',
    width: 150,
    renderCell: params => <span>{params?.row?.parent_account_code_data?.code || ''}</span>
  },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 120,
    renderCell: params => {
      if (params.value === '1') return <span>Còn sử dụng</span>;
      if (params.value === '0') return <span>Không sử dụng</span>;
      return <span>{String(params.value ?? '')}</span>;
    }
  }
];

export const documentTypeColumns: DataTableColumn<NhomLoaiHD>[] = [
  {
    field: 'ma_nhom',
    headerName: 'Mã nhóm loại hd',
    width: 150
  },
  {
    field: 'ten_nhom',
    headerName: 'Tên nhóm loại hd',
    width: 250
  },
  {
    field: 'ten_nhom2',
    headerName: 'Tên khác',
    width: 200
  },
  {
    field: 'status',
    headerName: 'Trạng thái',
    width: 120,
    renderCell: params => {
      if (params.value === '1') return <span>Còn sử dụng</span>;
      if (params.value === '0') return <span>Không sử dụng</span>;
      return <span>{String(params.value ?? '')}</span>;
    }
  }
];
